declare global {
  interface Window {
    __ENV__?: {
      API_URL?: string;
      APP_ENV?: string;
    };
  }
}

export const API_URL =
  window.__ENV__?.API_URL ??
  process.env.REACT_APP_NS_DEV_API_URL ??
  "http://localhost:3000";

export const APP_ENV = window.__ENV__?.APP_ENV ?? "development";
